(() => {
  const accordionButtons = (scope = document) => scope.querySelectorAll('[data-cv-accordion-button]');

  const setExpanded = (button, expanded) => {
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;
    button.setAttribute('aria-expanded', String(expanded));
    panel.hidden = !expanded;
  };

  const bindAccordions = (scope = document) => {
    accordionButtons(scope).forEach((button) => {
      if (button.dataset.cvAccordionReady === 'true') return;
      button.dataset.cvAccordionReady = 'true';
      button.addEventListener('click', () => {
        setExpanded(button, button.getAttribute('aria-expanded') !== 'true');
      });
      button.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        setExpanded(button, button.getAttribute('aria-expanded') !== 'true');
      });
    });
  };

  const enhanceFaqContent = (root) => {
    if (root.dataset.cvFaqReady === 'true') return;
    root.dataset.cvFaqReady = 'true';

    const headings = [...root.querySelectorAll('h3')];
    headings.forEach((heading, index) => {
      const item = document.createElement('div');
      const trigger = document.createElement('button');
      const panel = document.createElement('div');
      const triggerId = `cv-faq-trigger-${root.dataset.cvFaqId}-${index}`;
      const panelId = `cv-faq-panel-${root.dataset.cvFaqId}-${index}`;

      item.className = 'cv-faq-enhanced__item';
      trigger.className = 'cv-faq-enhanced__trigger';
      trigger.type = 'button';
      trigger.id = triggerId;
      trigger.textContent = heading.textContent.trim();
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-controls', panelId);
      trigger.setAttribute('data-cv-accordion-button', '');

      panel.className = 'cv-faq-enhanced__panel';
      panel.id = panelId;
      panel.setAttribute('role', 'region');
      panel.setAttribute('aria-labelledby', triggerId);
      panel.hidden = true;

      heading.before(item);
      item.append(trigger, panel);

      let sibling = heading.nextSibling;
      while (sibling && !(sibling.nodeType === 1 && /^(H2|H3)$/.test(sibling.tagName))) {
        const next = sibling.nextSibling;
        panel.append(sibling);
        sibling = next;
      }
      heading.remove();
    });

    bindAccordions(root);
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-cv-faq-enhance]').forEach(enhanceFaqContent);
    bindAccordions(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
